import beeIcon from '../../assets/icons/assistant-bee.png';
import owlIcon from '../../assets/icons/assistant-owl.png';
import squirrelIcon from '../../assets/icons/assistant-squirrel.png';
import { MarkdownRenderer } from './MarkdownRenderer';

interface StreamingChatBubbleProps {
  message: string;
  model?: 'norm' | 'exp' | 'eco';
}

const MODEL_INFO = {
  norm: { name: 'Bee', icon: beeIcon },
  exp: { name: 'Owl', icon: owlIcon },
  eco: { name: 'Squirrel', icon: squirrelIcon }
};

/**
 * StreamingChatBubble Component
 * 
 * Displays AI conversational messages from [CHAT] blocks during streaming.
 * Styled to match ChatMessage exactly for seamless transition when streaming completes.
 */
export function StreamingChatBubble({ message, model = 'norm' }: StreamingChatBubbleProps) {
  const modelInfo = MODEL_INFO[model];
  
  return (
    <div className="py-6 px-6">
      <div className="flex items-start gap-3">
        {/* Avatar - matches ChatMessage assistant avatar */}
        <img 
          src={modelInfo.icon} 
          alt={modelInfo.name} 
          className="flex-shrink-0 w-8 h-8 object-contain rounded-full" 
        />
        
        {/* Content - matches ChatMessage structure */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-sm font-semibold text-gray-900 dark:text-dark-text">
              {modelInfo.name}
            </span>
            <span className="text-xs text-gray-500 dark:text-dark-text-muted">
              just now
            </span>
          </div>
          <MarkdownRenderer 
            content={message} 
            className="text-sm leading-relaxed break-words text-gray-700 dark:text-dark-text"
          />
        </div>
      </div>
    </div>
  );
}
